import { render, staticRenderFns } from "./PrintMachineDashboard.vue?vue&type=template&id=2f731820&scoped=true&"
import script from "./PrintMachineDashboard.vue?vue&type=script&lang=js&"
export * from "./PrintMachineDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PrintMachineDashboard.vue?vue&type=style&index=0&id=2f731820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f731820",
  null
  
)

export default component.exports